/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { AgentToggleData, InterruptAgentApiArg } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    interruptAgent: build.mutation<AgentToggleData, InterruptAgentApiArg>({
      query: (queryArg) => ({
        body: undefined,
        method: 'POST',
        url: `/v1/conversations/${queryArg.conversationId}/interrupt`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as interruptAgentApi };
export const { useInterruptAgentMutation } = injectedRtkApi;
